module.exports = "/_next/static/images/CollectDataTabs-3@2x-4ae9ffaef13f5aee5089242043e1d6b6.webp";